import './index.css';
import './index.scss';
import './Utils/i18n';

import {GoogleOAuthProvider} from '@react-oauth/google';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import {
    BrowserRouter,
    Route,
    Routes,
} from 'react-router-dom';

import App from './App';
import { GA_MEASUREMENT_ID, GOOGLE_OAUTH_CLIENT_KEY } from './config';
import { AuthProvider } from './Contexts/AuthProvider';
import { CraRdvProvider } from './Contexts/CraRdvProvider';
import { PlateformeUtilitiesProvider } from './Contexts/PlateformeUtilitiesProvider';
import store from './Contexts/reduxStore';
import { GlobalContextProvider } from './Contexts/suiviMission/GlobalContext';
import reportWebVitals from './reportWebVitals';
//Initialize GA4
ReactGA.initialize(GA_MEASUREMENT_ID);

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
    <StrictMode>
        <BrowserRouter>
            {/* Context API */}
            <PlateformeUtilitiesProvider>
                <AuthProvider>
                    {/* Redux */}
                    <Provider store={store} >
                        {/* //! cra section : TRY TO RASSEMBLE THEM LATER : CRA + MISSION*/}
                        <CraRdvProvider>
                            {/* //! suiviMIssion section */}
                            <GlobalContextProvider>
                                <GoogleOAuthProvider
                                    clientId={GOOGLE_OAUTH_CLIENT_KEY.clientId}
                                >
                                    <Routes>
                                        <Route
                                            path='/*'
                                            element={<App />}
                                        />
                                    </Routes>
                                </GoogleOAuthProvider>
                            </GlobalContextProvider>
                        </CraRdvProvider>
                    </Provider>
                </AuthProvider>
            </PlateformeUtilitiesProvider>
        </BrowserRouter>
    </StrictMode>
    ,
    document.getElementById('root')

);
// * GA
const SendAnalytics = ()=> {
    ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
    });
};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(SendAnalytics);

{/* <Board
    data={{
        lanes: [
            {
                id: 'lane1',
                title: 'Planned Tasks',
                label: '2/2',
                cards: [
                    {id: 'Card1', title: 'Write Blog', description: 'Can AI make memes', label: '30 mins', draggable: false},
                    {id: 'Card2', title: 'Pay Rent', description: 'Transfer via NEFT', label: '5 mins', metadata: {sha: 'be312a1'}}
                ]
            },
            {
                id: 'lane2',
                title: 'Completed',
                label: '0/0',
                cards: []
            }
        ]
    }}
    // draggable
    // components={{ Card: myCard }}
    style={{ backgroundColor: '#FFFFFF' }}
    laneStyle={{
        backgroundColor: '#E9ECF1',
        borderRadius: '10px',
        width: '350px',
    }}
    cardStyle={{ backgroundColor: '#FFFFFF' }}
/>; */}